import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Input from './AirDatePickerInput';
import { registerLocale } from 'react-datepicker';

import './AirDatePicker.css';

@inject('commonStore', 'translationsStore')
@observer
export default class AirDatePicker extends Component {
  render() {
    const {
      translationsStore,
      commonStore: { dateFnsLocale }
    } = this.props;
    registerLocale('locale', dateFnsLocale);
    return (
      <DatePicker
        locale="locale"
        dateFormat={translationsStore.translate('datepickerFormat')}
        showYearDropdown
        className="AirDatePicker"
        {...this.props}
        customInput={<Input prefix={this.props.prefix} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirDatePicker/AirDatePicker.js